import OurFlowPanel from 'components/Organisms/OurFlowPanel';
import OurOffers from 'components/Organisms/OurOffers';
import OurProducts from 'components/Organisms/OurProducts';
import SEO from 'components/SEO';
import LoadableSpinner from 'components/Universal/LoadableSpinner';
import HeaderContext from 'providers/HeaderProvider';
import React, { useContext, useEffect } from 'react';
import loadable from '@react-loadable/revised'
import { useMediaQuery } from 'react-responsive';
import { css } from 'twin.macro';

const CarouselList = loadable({
	loader: () => import('components/Organisms/CarouselList'),
	loading: LoadableSpinner
});

const FlowStructure = loadable({
	loader: () => import('components/Organisms/FlowStructure'),
	loading: LoadableSpinner
});

const backgroundImage = css`
	position: relative;
	background-image: url(../files/task-list.png);
	background-position: center top;
	background-repeat: no-repeat;
	background-size: contain;

	&:before {
	content: '';
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: rgba(255,255,255,0.75);
}
`;

export default function Home() {
	const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1025 });
	const { setHeader } = useContext(HeaderContext);

	useEffect(() => {
		setHeader({ isMain: true });
	}, []);

	return (
		<div>
			<SEO />

			<div className='py-12 px-18'>
				<div className='flex items-center justify-between'>
					<div className='w-1/2'>
						<p className='text-20'>O nas</p>
						<p className='font-lat my-05 pr-05 text-11'>Codziennie pomagamy utrzymać płynność finansową wielu firmom działającym w Polsce i na świecie. Zapewniamy środki na Twoją działalność i umożliwiamy szybszy rozwój. Staramy się być doskonali - dla Ciebie.</p>
					</div>
					<img src='files/people.png' alt='Faktoring przyjazny dla Ciebie' className='w-120' width='initial' height='initial' />
				</div>
				<p className='font-lat text-11'>Obsługujemy wszystkie rodzaje działalności, bez względu na ich wielkość, formę prawną oraz wiek. Jedynym warunkiem rozpoczęcia współpracy jest posiadanie stałych odbiorców dla których wystawiasz faktury z odroczonym terminem płatności i chcesz mieć dostęp do gotówki od razu po jej wystawieniu.</p>
			</div>

			<div>
				<div css={[backgroundImage]} className='flex flex-col items-center justify-start pt-60'>
					<p className='text-16 relative mb-30'>Jak zacząć?</p>
					<OurFlowPanel />
				</div>
			</div>

			{!isDesktopOrLaptop && <CarouselList />}
			<OurProducts />
			<OurOffers />

			<FlowStructure title='Podpisałem umowę, co dalej?' subtitle='Resztę zrobimy za Ciebie. Proces przetwarzania faktury przedstawia poniższy schemat:' />

			<div className='border-t border-solid border-grey-D px-15 font-lat text-grey-9 mb-10'>
				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p>Dostarczasz towar lub usługę dla swojego odbiorcy. Fakt dostawy potwierdzasz dokumentami np. Fakturą, protokół odbioru lub WZ.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Kopie dokumentów potwierdzających dostawę towaru lub wykonanie usługi dostarczasz do Smart Faktor.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p className='w-4/5'>Natychmiast otrzymujesz od nas płatność zaliczkową zgodnie z warunkami umowy.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>4</div>
					<p className='w-4/5'>Po upływie terminu płatności Twój klient opłaca fakturę do Smart Faktor.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>5</div>
					<p className='w-4/5'>Natychmiast otrzymujesz od nas płatność końcową zgodnie z warunkami umowy.</p>
				</div>
			</div>
		</div>
	);
}
